
import React, { Component } from 'react';
import './Portfolio.css'

import Img1 from '../img/portfolio/01-thumbnail.jpg'
import Img2 from '../img/portfolio/02-thumbnail.jpg'
import Img3 from '../img/portfolio/03-thumbnail.jpg'
import Img4 from '../img/portfolio/04-thumbnail.jpg'
import Img5 from '../img/portfolio/05-thumbnail.jpg'


 class portfolio extends Component {
  render() {
    return (
        <div id="portfolio" className="portfolio">
        <div>
                    <h1 className="protheading">Portfolio</h1>
                    <div>
                    <p className="portprag">You can add your Project  wherever you want.</p>
                   
                    

                     <label className="portfoliobtn" htmlFor="modal-1">
                        
                                <div className=" portfolio-item">
                                    
                                    <img className="img-fluid" src={Img1} alt="" />
                                <div className="portfolio-caption">
                                    <h4>Threads</h4>
                                    <p className="text-muted">Illustration Use this area to describe your project. Lorem ipsum dolor sit amet,</p>
                                </div>
                                </div>
                                </label>
                      
                       <label className="portfoliobtn" htmlFor="modal-2">
                        
                                <div className=" portfolio-item">
                                    
                                    <img className="img-fluid" src={Img2} alt="" />
                                <div className="portfolio-caption">
                                    <h4>Threads</h4>
                                    <p className="text-muted">Illustration Use this area to describe your project. Lorem ipsum dolor sit amet,</p>
                                </div>
                                </div>
                                </label>
                       
                         <label className="portfoliobtn" htmlFor="modal-3">
                        
                                <div className=" portfolio-item">
                                    
                                    <img className="img-fluid" src={Img3} alt="" />
                                <div className="portfolio-caption">
                                    <h4>Threads</h4>
                                    <p className="text-muted">Illustration Use this area to describe your project. Lorem ipsum dolor sit amet,</p>
                                </div>
                                </div>
                        </label>
                        <label className="portfoliobtn" htmlFor="modal-4">
                        
                                <div className=" portfolio-item">
                                    
                                    <img className="img-fluid" src={Img4} alt="" />
                                <div className="portfolio-caption">
                                    <h4>Threads</h4>
                                    <p className="text-muted">Illustration Use this area to describe your project. Lorem ipsum dolor sit amet,</p>
                                </div>
                                </div>
                                </label>
                        <label className="portfoliobtn" htmlFor="modal-5">
                        
                                <div className=" portfolio-item">
                                    
                                    <img className="img-fluid" src={Img5} alt="" />
                                <div className="portfolio-caption">
                                    <h4>Threads</h4>
                                    <p className="text-muted">Illustration Use this area to describe your project. Lorem ipsum dolor sit amet,</p>
                                </div>
                                </div>
                                </label>
                     
                     </div>   









                    <input className="modal-state" id="modal-1" type="checkbox" />
                    <div className="modal">
                    <label className="modal__bg" htmlFor="modal-1"></label>
                    <div className="modal__inner">
                        <label className="modal__close" htmlFor="modal-1"></label>
                                    <h2 className="text-uppercase">Project 1</h2>
                            <p className="item-intro text-muted">Lorem ipsum dolor sit amet consectetur.</p>
                            <img className="img-fluid d-block mx-auto" src={Img1} alt="" />
                            <p>Use this area to describe your project. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est blanditiis dolorem culpa incidunt minus dignissimos deserunt repellat aperiam quasi sunt officia expedita beatae cupiditate, maiores repudiandae, nostrum, reiciendis facere nemo!</p>
                            <ul className="list-inline">
                            <li>Date: January 2017</li>
                            <li>Client: Threads</li>
                            <li>Category: Illustration</li>
                            <li>Project weblink</li>
                            <li><a href="1" target = "_blank" rel="noopener noreferrer">click here</a></li>
                            </ul>
                    </div>
                    </div>


                    <input className="modal-state" id="modal-2" type="checkbox" />
                    <div className="modal">
                    <label className="modal__bg" htmlFor="modal-2"></label>
                    <div className="modal__inner">
                        <label className="modal__close" htmlFor="modal-2"></label>
                                    <h2 className="text-uppercase">Project 2</h2>
                            <p className="item-intro text-muted">Lorem ipsum dolor sit amet consectetur.</p>
                            <img className="img-fluid d-block mx-auto" src={Img2} alt="" />
                            <p>Use this area to describe your project. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est blanditiis dolorem culpa incidunt minus dignissimos deserunt repellat aperiam quasi sunt officia expedita beatae cupiditate, maiores repudiandae, nostrum, reiciendis facere nemo!</p>
                            <ul className="list-inline">
                            <li>Date: January 2017</li>
                            <li>Client: Threads</li>
                            <li>Category: Illustration</li>
                            </ul>
                    </div>
                    </div>



                    <input className="modal-state" id="modal-3" type="checkbox" />
                    <div className="modal">
                    <label className="modal__bg" htmlFor="modal-3"></label>
                    <div className="modal__inner">
                        <label className="modal__close" htmlFor="modal-3"></label>
                                    <h2 className="text-uppercase">Project 3</h2>
                            <p className="item-intro text-muted">Lorem ipsum dolor sit amet consectetur.</p>
                            <img className="img-fluid d-block mx-auto" src={Img3} alt="" />
                            <p>Use this area to describe your project. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est blanditiis dolorem culpa incidunt minus dignissimos deserunt repellat aperiam quasi sunt officia expedita beatae cupiditate, maiores repudiandae, nostrum, reiciendis facere nemo!</p>
                            <ul className="list-inline">
                            <li>Date: January 2017</li>
                            <li>Client: Threads</li>
                            <li>Category: Illustration</li>
                            </ul>
                    </div>
                    </div>
                


                    <input className="modal-state" id="modal-4" type="checkbox" />
                    <div className="modal">
                    <label className="modal__bg" htmlFor="modal-244"></label>
                    <div className="modal__inner">
                        <label className="modal__close" htmlFor="modal-4"></label>
                                    <h2 className="text-uppercase">Project 4</h2>
                            <p className="item-intro text-muted">Lorem ipsum dolor sit amet consectetur.</p>
                            <img className="img-fluid d-block mx-auto" src={Img4} alt="" />
                            <p>Use this area to describe your project. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est blanditiis dolorem culpa incidunt minus dignissimos deserunt repellat aperiam quasi sunt officia expedita beatae cupiditate, maiores repudiandae, nostrum, reiciendis facere nemo!</p>
                            <ul className="list-inline">
                            <li>Date: January 2017</li>
                            <li>Client: Threads</li>
                            <li>Category: Illustration</li>
                            </ul>
                    </div>
                    </div>


                    <input className="modal-state" id="modal-5" type="checkbox" />
                    <div className="modal">
                    <label className="modal__bg" htmlFor="modal-5"></label>
                    <div className="modal__inner">
                        <label className="modal__close" htmlFor="modal-5"></label>
                                    <h2 className="text-uppercase">Project 5</h2>
                            <p className="item-intro text-muted">Lorem ipsum dolor sit amet consectetur.</p>
                            <img className="img-fluid d-block mx-auto" src={Img5} alt="" />
                            <p>Use this area to describe your project. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est blanditiis dolorem culpa incidunt minus dignissimos deserunt repellat aperiam quasi sunt officia expedita beatae cupiditate, maiores repudiandae, nostrum, reiciendis facere nemo!</p>
                            <ul className="list-inline">
                            <li>Date: January 2017</li>
                            <li>Client: Threads</li>
                            <li>Category: Illustration</li>
                            </ul>
                    </div>
                    </div>    


                
                </div>    
            </div>
            
      
    );
  }
}

export default portfolio;

